import React, { useEffect, useState } from "react";
import {
  Grid,
  Paper,
  Typography,
  Pagination,
  IconButton,
  MenuItem,
  Menu,
  Avatar,
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  FormControl,
  InputLabel,
  Select,
  Tabs,
  Tab,
  Badge,
} from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PeopleIcon from "@mui/icons-material/People";
import InfoIcon from "@mui/icons-material/Info";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useSelector } from "react-redux";
import AdminService from "../services/adminService.js";
import Loader from "../components/Loader.jsx";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { describeSubscription } from "../utils/subscription";

const ManageAppUsers = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [menuAnchorEls, setMenuAnchorEls] = useState({});
  const [openDetailDialog, setOpenDetailDialog] = useState(false);
  const [openTrialDialog, setOpenTrialDialog] = useState(false);
  const [openPromoteDialog, setOpenPromoteDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [extraDays, setExtraDays] = useState(0);
  const [selectedRole, setSelectedRole] = useState("user");
  const [isSubmittingTrial, setIsSubmittingTrial] = useState(false);
  const [isSubmittingPromote, setIsSubmittingPromote] = useState(false);

  // --- Invitation State ---
  const [tabValue, setTabValue] = useState(0);
  const [openInviteDialog, setOpenInviteDialog] = useState(false);
  const [inviteEmail, setInviteEmail] = useState("");
  const [isSubmittingInvite, setIsSubmittingInvite] = useState(false);
  const [inviteSearch, setInviteSearch] = useState("");
  const [invites, setInvites] = useState([]);
  const [loadingInvites, setLoadingInvites] = useState(false);

  const { token, roles } = useSelector((state) => state.user);

  const isAdmin = roles?.includes("admin");

  const navigate = useNavigate();

  // ---------------- FETCH USERS ----------------
  const loadData = async () => {
    setLoading(true);
    try {
      // get token from Redux

      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/fetchusers?page=${
          page + 1
        }&limit=${limit}&searchKey=${searchTerm}&userType=${isAdmin ? "admin" : "appuser"}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`, // Bearer token
            "x-client-type": "web", // custom header
            "Content-Type": "application/json", // optional but safe
          },
        },
      );

      const result = await res.json();
      console.log("Fetch users result:", result);

      if (result?.data) {
        setUsers(result.data);
        setTotalPages(result.totalPages || 1);
      }
    } catch (err) {
      console.error("Fetch users error:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    const t = setTimeout(loadData, 400);
    return () => clearTimeout(t);
  }, [page, limit, searchTerm]);

  // ---------------- MENU ----------------
  const handleMenuClick = (e, id) => {
    setMenuAnchorEls((prev) => ({ ...prev, [id]: e.currentTarget }));
  };

  const handleMenuClose = (id) => {
    console.log(id);
    setMenuAnchorEls((prev) => ({ ...prev, [id]: null }));
  };
  const handleBlockUser = async (userId) => {
    try {
      const updatedUser = await AdminService.suspendUser(userId);

      // ✅ update popup
      setSelectedUser({ ...updatedUser });

      // ✅ update table list
      setUsers((prev) => prev.map((u) => (u._id === userId ? updatedUser : u)));

      // ✅ Close dialog
      setOpenDetailDialog(false);

      // ✅ Refetch data from API to get latest updates
      await loadData();
    } catch (err) {
      console.error(err);
    }
  };

  const handleUnblockUser = async (userId) => {
    try {
      const updatedUser = await AdminService.unsuspendUser(userId);

      setSelectedUser({ ...updatedUser });

      setUsers((prev) => prev.map((u) => (u._id === userId ? updatedUser : u)));

      // ✅ Close dialog
      setOpenDetailDialog(false);

      // ✅ Refetch data from API to get latest updates
      await loadData();
    } catch (err) {
      console.error(err);
    }
  };

  const handleExtendTrial = async () => {
    if (!selectedUser || extraDays <= 0) return;

    setIsSubmittingTrial(true);
    try {
      await AdminService.extendTrial(selectedUser._id, Number(extraDays));
      setOpenTrialDialog(false);
      setExtraDays(0);
      await loadData();
    } catch (err) {
      console.error("Extend trial error:", err);
    } finally {
      setIsSubmittingTrial(false);
    }
  };

  // const handlePromoteUser = async () => {
  //   if (!selectedUser || !selectedRole) return;

  //   setIsSubmittingPromote(true);
  //   try {
  //     const res = await AdminService.promoteUser(
  //       selectedUser._id,
  //       selectedRole,
  //     );

  //     setOpenPromoteDialog(false);
  //     await loadData();
  //   } catch (err) {
  //     console.error("Promote user eddfrror:", err.response?.data?.error || err.message);
  //     // toast.error(
  //     //   err.response?.data?.message ||
  //     //     err.response?.data?.error ||
  //     //     "Failed to updateyh user role",
  //     // );
  //   } finally {
  //     setIsSubmittingPromote(false);
  //   }
  // };

  const handlePromoteUser = async () => {
    if (!selectedUser || !selectedRole) return;

    setIsSubmittingPromote(true);

    try {
      await AdminService.promoteUser(selectedUser._id, selectedRole);

      toast.success("User role updated successfully");

      setOpenPromoteDialog(false);
      await loadData();
    } catch (err) {
      if (err.response?.status === 403) {
        toast.error("You don't have permission to perform this action");
      } else {
        toast.error(
          err.response?.data?.message || "Failed to update user role",
        );
      }
    } finally {
      setIsSubmittingPromote(false);
    }
  };
  const loadInvites = async () => {
    setLoadingInvites(true);
    try {
      const data = await AdminService.fetchInvites();
      setInvites(data);
    } catch (err) {
      console.error("Fetch invites error:", err);
    } finally {
      setLoadingInvites(false);
    }
  };

  useEffect(() => {
    if (tabValue === 1) {
      loadInvites();
    }
  }, [tabValue]);

  const handleInviteUser = async () => {
    if (!inviteEmail) return;
    setIsSubmittingInvite(true);
    try {
      await AdminService.inviteUser(inviteEmail);
      setOpenInviteDialog(false);
      setInviteEmail("");
      await loadInvites(); // Refresh the list
    } catch (err) {
      console.error("Invite user error:", err);
    } finally {
      setIsSubmittingInvite(false);
    }
  };

  const handleCancelInvitation = async (email, id) => {
    try {
      await AdminService.cancelInvitation(email);
      handleMenuClose(id);
      await loadInvites();
    } catch (err) {
      console.error("Cancel invitation error:", err);
    }
  };

  const handleDeleteAllData = async (userId) => {
    // ... implementation same as before
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Grid container spacing={2} className="w-full max-w-full">
      <Grid item xs={12}>
        <div className="mb-6">
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              "& .MuiTabs-indicator": { backgroundColor: "#6366f1" },
              "& .MuiTab-root": {
                fontWeight: 700,
                textTransform: "none",
                fontSize: "0.95rem",
              },
              "& .Mui-selected": { color: "#6366f1 !important" },
            }}
          >
            <Tab
              icon={<PeopleIcon size={18} />}
              iconPosition="start"
              label="Manage App Users"
            />
            {isAdmin ? (
              <Tab
                icon={<PersonAddIcon size={18} />}
                iconPosition="start"
                label="Invite/View App User"
              />
            ) : (
              <></>
            )}
          </Tabs>
        </div>

        {tabValue === 0 && (
          <Paper sx={{ p: 4, width: "100%", maxWidth: "100%" }} elevation={1}>
            {/* HEADER */}
            <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
              <Typography variant="h5" fontWeight={600}>
                Manage App Users
              </Typography>

              <div className="flex items-center gap-3">
                {/* SEARCH */}
                <TextField
                  size="small"
                  placeholder="Search name or email"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setPage(0);
                  }}
                />

                {/* LIMIT */}
                <div className="flex items-center gap-1">
                  <span className="text-sm">Rows:</span>
                  <select
                    value={limit}
                    onChange={(e) => {
                      setLimit(Number(e.target.value));
                      setPage(0);
                    }}
                    className="border rounded px-2 py-1 text-sm"
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </select>
                </div>
              </div>
            </div>

            {/* TABLE */}
            <TableContainer
              sx={{
                width: "100%",
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <Table
                sx={{
                  width: "100%",
                  minWidth: "100%",
                  tableLayout: "fixed",
                }}
              >
                {/* TABLE HEAD */}
                <TableHead className="bg-gray-100">
                  <TableRow>
                    <TableCell sx={{ width: "20%", fontWeight: "bold" }}>
                      User
                    </TableCell>
                    <TableCell sx={{ width: "25%", fontWeight: "bold" }}>
                      Email
                    </TableCell>

                    <TableCell
                      sx={{
                        width: "15%",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Provider
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "10%",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Joined
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "10%",
                        textAlign: "right",
                        fontWeight: "bold",
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                {/* TABLE BODY */}
                <TableBody
                  sx={{
                    "&:hover .table-row": {
                      filter: "blur(0.1px)",
                      opacity: 0.5,
                    },
                    "&:hover .table-row:hover": {
                      filter: "none",
                      opacity: 1,
                      backgroundColor: "#F9FAFB",
                    },
                  }}
                >
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Loader />
                      </TableCell>
                    </TableRow>
                  ) : users.length ? (
                    users.map((u) => {
                      console.log("User:", u.email, "Roles:", u.role);
                      const isTargetAdmin = u.role?.includes("admin");
                      const isUser = u.role?.includes("user");
                      return (
                        <TableRow
                          key={u._id}
                          className="table-row"
                          sx={{
                            transition: "filter 0.15s ease, opacity 0.15s ease",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            if (menuAnchorEls[u._id]) return;
                            navigate(`/admin/dash/users/${u._id}`);
                          }}
                        >
                          {/* USER COLUMN */}
                          <TableCell sx={{ width: "20%" }}>
                            <div className="flex items-center gap-3">
                              <Badge
                                overlap="circular"
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                badgeContent={
                                  // Both arms of this used to render the same
                                  // orange icon, so the badge told an admin
                                  // nothing. It now reflects real entitlement:
                                  // green = access, grey = none.
                                  <LoyaltyIcon
                                    titleAccess={
                                      describeSubscription(u.subscription).hint
                                    }
                                    sx={{
                                      color: "white",
                                      bgcolor: describeSubscription(u.subscription)
                                        .hasAccess
                                        ? "success.main"
                                        : "grey.400",
                                      borderRadius: "50%",
                                      fontSize: "1.1rem",
                                      padding: "2px",
                                      border: "2px solid white",
                                    }}
                                  />
                                }
                              >
                                <Avatar
                                  src={u.avatar}
                                  sx={{
                                    bgcolor: describeSubscription(u.subscription)
                                      .hasAccess
                                      ? "success.main"
                                      : "grey.400",
                                    border: describeSubscription(u.subscription)
                                      .hasAccess
                                      ? "2px solid #2e7d32"
                                      : "none",
                                  }}
                                  imgProps={{
                                    referrerPolicy: "no-referrer",
                                    loading: "lazy",
                                  }}
                                >
                                  {u.name?.[0]}
                                </Avatar>
                              </Badge>
                              <div className="min-w-0">
                                <p className="font-medium truncate">{u.name}</p>
                                {u.isdeleted && (
                                  <span className="text-xs text-red-500">
                                    Deleted
                                  </span>
                                )}
                              </div>
                            </div>
                          </TableCell>

                          {/* EMAIL COLUMN */}
                          <TableCell
                            sx={{
                              width: "25%",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            title={u.email}
                          >
                            {u.email}
                          </TableCell>

                          {/* PROVIDER COLUMN */}
                          <TableCell sx={{ width: "15%", textAlign: "center" }}>
                            <Chip
                              size="small"
                              label={
                                u.authProvider === "google+apple"
                                  ? "both"
                                  : u.authProvider
                              }
                              sx={{
                                minWidth: 90,
                                fontWeight: 600,
                                bgcolor:
                                  u.authProvider === "google"
                                    ? "#E8F5E9"
                                    : u.authProvider === "apple"
                                      ? "#E3F2FD"
                                      : "#FFF8E1",
                                color:
                                  u.authProvider === "google"
                                    ? "#2E7D32"
                                    : u.authProvider === "apple"
                                      ? "#1565C0"
                                      : "#EF6C00",
                              }}
                            />
                          </TableCell>

                          {/* JOINED COLUMN */}
                          <TableCell sx={{ width: "10%", textAlign: "center" }}>
                            {new Date(u.createdAt).toLocaleDateString("en-GB")}
                          </TableCell>

                          {/* ACTIONS COLUMN */}
                          <TableCell sx={{ width: "10%", textAlign: "right" }}>
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMenuClick(e, u._id);
                              }}
                            >
                              <MoreVertIcon />
                            </IconButton>
                            <Menu
                              anchorEl={menuAnchorEls[u._id]}
                              open={Boolean(menuAnchorEls[u._id])}
                              onClose={(e) => {
                                e.stopPropagation();
                                handleMenuClose(u._id);
                              }}
                            >
                              <MenuItem
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedUser({ ...u });
                                  setOpenDetailDialog(true);
                                  handleMenuClose(u._id);
                                }}
                              >
                                <VisibilityIcon fontSize="small" /> &nbsp; View
                                Details
                              </MenuItem>
                              {/* <MenuItem
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedUser({ ...u });
                                  setOpenTrialDialog(true);
                                  handleMenuClose(u._id);
                                }}
                              >
                                <EventAvailableIcon fontSize="small" /> &nbsp;
                                Trial extension
                              </MenuItem> */}
                              {isAdmin && !isTargetAdmin && (
                                <MenuItem
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedUser({ ...u });

                                    setSelectedRole(
                                      isUser ? "subscriber" : "user",
                                    );

                                    setOpenPromoteDialog(true);
                                    handleMenuClose(u._id);
                                  }}
                                >
                                  <ArrowForwardIcon fontSize="small" /> &nbsp;
                                  {isUser
                                    ? "Reback to Subscriber"
                                    : "Promote User"}
                                </MenuItem>
                              )}
                            </Menu>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Box
                          sx={{
                            py: 5,
                            color: "text.secondary",
                            textAlign: "center",
                          }}
                        >
                          <Typography variant="subtitle1" fontWeight={600}>
                            No users available
                          </Typography>
                          <Typography variant="body2">
                            User list is currently empty
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* PAGINATION */}
            <div className="flex justify-center mt-4">
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={(e, v) => setPage(v - 1)}
              />
            </div>
          </Paper>
        )}

        {tabValue === 1 && (
          <Paper sx={{ p: 4, width: "100%", maxWidth: "100%" }} elevation={1}>
            <div className="flex items-center justify-between gap-4 mb-6">
              <Typography variant="h5" fontWeight={600}>
                Invitations
              </Typography>

              <div className="flex items-center gap-3">
                <TextField
                  size="small"
                  placeholder="Search invitee..."
                  value={inviteSearch}
                  onChange={(e) => setInviteSearch(e.target.value)}
                />
                <Button
                  variant="contained"
                  startIcon={<PersonAddIcon />}
                  onClick={() => setOpenInviteDialog(true)}
                  sx={{
                    bgcolor: "#6366f1",
                    borderRadius: "10px",
                    "&:hover": { bgcolor: "#4f46e5" },
                  }}
                >
                  Invite User
                </Button>
              </div>
            </div>

            <TableContainer
              sx={{
                width: "100%",
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <Table
                sx={{
                  width: "100%",
                  minWidth: "100%",
                  tableLayout: "fixed",
                }}
              >
                <TableHead className="bg-gray-100 w-100">
                  <TableRow>
                    <TableCell sx={{ width: "40%" }}>Email</TableCell>
                    <TableCell align="center" sx={{ width: "20%" }}>
                      Status
                    </TableCell>
                    <TableCell align="center" sx={{ width: "25%" }}>
                      Invited At
                    </TableCell>
                    <TableCell align="right" sx={{ width: "15%" }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loadingInvites ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        <Loader />
                      </TableCell>
                    </TableRow>
                  ) : invites.length > 0 ? (
                    invites
                      .filter((i) =>
                        i.email
                          .toLowerCase()
                          .includes(inviteSearch.toLowerCase()),
                      )
                      .map((invite) => (
                        <TableRow key={invite._id} hover>
                          <TableCell className="font-medium">
                            {invite.email}
                          </TableCell>
                          <TableCell align="center">
                            <Chip
                              label={invite.status}
                              size="small"
                              color={
                                invite.status === "active"
                                  ? "success"
                                  : "warning"
                              }
                              variant="outlined"
                            />
                          </TableCell>
                          <TableCell align="center">
                            {new Date(invite.createdAt).toLocaleDateString()}
                          </TableCell>
                          <TableCell align="right">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMenuClick(e, invite._id);
                              }}
                            >
                              <MoreVertIcon />
                            </IconButton>

                            <Menu
                              anchorEl={menuAnchorEls[invite._id]}
                              open={Boolean(menuAnchorEls[invite._id])}
                              onClose={(e) => {
                                e.stopPropagation();
                                handleMenuClose(invite._id);
                              }}
                            >
                              <MenuItem
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCancelInvitation(
                                    invite.email,
                                    invite._id,
                                  );
                                }}
                              >
                                {invite.status === "active"
                                  ? "Reback to subscrib"
                                  : "Cancel invite"}
                              </MenuItem>
                            </Menu>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        <Box sx={{ py: 3, color: "text.secondary" }}>
                          No invitations found
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}

        {/* USER DETAIL DIALOG */}
        <Dialog
          open={openDetailDialog}
          onClose={() => setOpenDetailDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle className="text-lg font-semibold">
            User Details
          </DialogTitle>

          <DialogContent>
            {selectedUser && (
              <div className="flex flex-col items-center gap-4 py-4">
                {/* Avatar & Basic Info */}
                <Avatar
                  src={selectedUser.avatar}
                  imgProps={{ referrerPolicy: "no-referrer", loading: "lazy" }}
                  sx={{
                    width: 96,
                    height: 96,
                    border: describeSubscription(selectedUser.subscription)
                      .hasAccess
                      ? "4px solid #2e7d32"
                      : "none",
                  }}
                >
                  {selectedUser.name?.[0]}
                </Avatar>

                <p className="text-xl font-bold">{selectedUser.name}</p>

                <Chip
                  label={
                    [
                      selectedUser.isdeleted && "Deleted",
                      selectedUser.issuspended && "Suspended",
                    ]
                      .filter(Boolean)
                      .join(" + ") || "Active"
                  }
                  color={
                    selectedUser.isdeleted
                      ? "default"
                      : selectedUser.issuspended
                        ? "error"
                        : "success"
                  }
                  size="small"
                  className="font-semibold"
                />

                {/* Main Info Section */}
                <div className="w-full bg-gray-50 p-4 rounded-lg border border-gray-200 mt-3 space-y-2 text-sm">
                  <div>
                    <span className="font-semibold">Email: </span>
                    {selectedUser.email}
                  </div>

                  <div className="flex gap-2 flex-wrap items-center">
                    <span className="font-semibold">Roles: </span>
                    {(Array.isArray(selectedUser?.role)
                      ? selectedUser.role
                      : ["subscriber"]
                    ).map((r) => (
                      <Chip
                        key={r}
                        label={r}
                        size="small"
                        color={r === "admin" ? "secondary" : "default"}
                      />
                    ))}
                  </div>

                  <div>
                    <span className="font-semibold">Location: </span>
                    {selectedUser?.location
                      ? `${selectedUser.location.city || "-"}, ${selectedUser.location.state || "-"}`
                      : "Not Set"}
                  </div>
                </div>

                {/* --- NEW: SUBSCRIPTION SECTION --- */}
                {/* <div className="w-full bg-blue-50 p-4 rounded-lg border border-blue-100 space-y-2 text-sm">
                  <div className="flex justify-between items-center border-b border-blue-200 pb-2 mb-2">
                    <span className="font-bold text-blue-800 uppercase tracking-wider">
                      Subscription Plan
                    </span>
                    <Chip
                      label={
                        selectedUser.subscription?.subscriptionType?.toUpperCase() ||
                        "NONE"
                      }
                      color={
                        selectedUser.subscription?.subscriptionType === "paid"
                          ? "success"
                          : "warning"
                      }
                      size="small"
                    />
                  </div>

                  {selectedUser.subscription?.trialEndsAt && (
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-600">
                        Trial Expiry:
                      </span>
                      <span>
                        {new Date(
                          selectedUser.subscription.trialEndsAt,
                        ).toLocaleDateString("en-US", { dateStyle: "medium" })}
                      </span>
                    </div>
                  )}

                  {selectedUser.subscription?.expirationDate && (
                    <div className="flex justify-between">
                      <span className="font-semibold text-green-700">
                        Paid Expiry:
                      </span>
                      <span className="font-bold">
                        {new Date(
                          selectedUser.subscription.expirationDate,
                        ).toLocaleDateString("en-US", { dateStyle: "medium" })}
                      </span>
                    </div>
                  )}

                  {selectedUser.subscription?.productIdentifier && (
                    <div className="pt-2 border-t border-blue-100 text-xs text-gray-500">
                      <div>
                        <span className="font-semibold">Product:</span>{" "}
                        {selectedUser.subscription.productIdentifier}
                      </div>
                      <div>
                        <span className="font-semibold">ID:</span>{" "}
                        {selectedUser.subscription.transactionId || "N/A"}
                      </div>
                    </div>
                  )}
                </div> */}

                <div className="w-full text-center">
                  <span className="text-xs text-gray-400">
                    Joined:{" "}
                    {new Date(selectedUser.createdAt).toLocaleDateString(
                      "en-US",
                      { year: "numeric", month: "long", day: "numeric" },
                    )}
                  </span>
                </div>
              </div>
            )}
          </DialogContent>

          <DialogActions className="px-4 py-2">
            <Button onClick={() => setOpenDetailDialog(false)}>Close</Button>

            {selectedUser &&
              (() => {
                // ✅ normalize role to array
                const roles = Array.isArray(selectedUser.role)
                  ? selectedUser.role
                  : [selectedUser.role || "subscriber"];

                // ❌ admins cannot be suspended
                if (roles.includes("admin")) return null;

                // ✅ show correct button
                return !selectedUser.issuspended ? (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleBlockUser(selectedUser._id)}
                  >
                    Suspend User
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => handleUnblockUser(selectedUser._id)}
                  >
                    UnSuspend User
                  </Button>
                );
              })()}
          </DialogActions>
        </Dialog>

        {/* TRIAL EXTENSION DIALOG */}
        <Dialog
          open={openTrialDialog}
          onClose={() => !isSubmittingTrial && setOpenTrialDialog(false)}
          maxWidth="xs"
          fullWidth
        >
          {/* <DialogTitle className="text-xl font-bold flex items-center gap-2">
            <EventAvailableIcon className="text-blue-600" />
            Trial Extension
          </DialogTitle> */}

          <DialogContent>
            <Box sx={{ mt: 1 }}>
              {/* User Context Card */}
              <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200 mb-4">
                <Avatar
                  src={selectedUser?.avatar}
                  sx={{ width: 40, height: 40 }}
                >
                  {selectedUser?.name?.[0]}
                </Avatar>
                <div className="min-w-0">
                  <p className="font-semibold text-sm truncate">
                    {selectedUser?.name}
                  </p>
                  <p className="text-xs text-gray-500 truncate">
                    {selectedUser?.email}
                  </p>
                </div>
              </div>

              {/* Extension Input */}
              <Typography variant="subtitle2" className="font-bold mb-1">
                Add Extra Days
              </Typography>
              <TextField
                fullWidth
                placeholder="e.g. 7, 14, 30"
                type="number"
                variant="outlined"
                value={extraDays}
                onChange={(e) => setExtraDays(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                  backgroundColor: "white",
                }}
                inputProps={{ min: 1 }}
                autoFocus
              />

              {/* Visual Date Preview */}
              {selectedUser?.subscription?.trialEndsAt && (
                <div className="mt-5 p-4 rounded-xl bg-blue-50 border border-blue-100 flex justify-between items-center">
                  <div className="text-center flex-1">
                    <p className="text-[10px] uppercase text-gray-400 font-bold">
                      Current Expiry
                    </p>
                    <p className="text-sm font-medium text-gray-700">
                      {new Date(
                        selectedUser.subscription.trialEndsAt,
                      ).toLocaleDateString("en-GB")}
                    </p>
                  </div>

                  <div className="flex flex-col items-center px-2">
                    <ArrowForwardIcon
                      className="text-blue-300"
                      fontSize="small"
                    />
                    <span className="text-[10px] font-bold text-blue-500">
                      +{extraDays || 0}d
                    </span>
                  </div>

                  <div className="text-center flex-1">
                    <p className="text-[10px] uppercase text-blue-400 font-bold">
                      New Expiry
                    </p>
                    <p className="text-sm font-bold text-blue-700">
                      {(() => {
                        const current = new Date(
                          selectedUser.subscription.trialEndsAt,
                        );
                        current.setDate(
                          current.getDate() + (parseInt(extraDays) || 0),
                        );
                        return current.toLocaleDateString("en-GB");
                      })()}
                    </p>
                  </div>
                </div>
              )}
            </Box>
          </DialogContent>
          <DialogActions className="px-4 py-3">
            <Button
              onClick={() => setOpenTrialDialog(false)}
              disabled={isSubmittingTrial}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleExtendTrial}
              disabled={isSubmittingTrial || extraDays <= 0}
            >
              {isSubmittingTrial ? "Extending..." : "Extend Trial"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* PROMOTE USER DIALOG */}
        <Dialog
          open={openPromoteDialog}
          onClose={() => !isSubmittingPromote && setOpenPromoteDialog(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle className="text-lg font-semibold">
            Promote / Update User Role
          </DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 1 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Update role for <strong>{selectedUser?.name}</strong> (
                {selectedUser?.email})
              </Typography>
              <FormControl fullWidth sx={{ mt: 2 }}>
                <InputLabel id="role-select-label">Select Role</InputLabel>
                <Select
                  labelId="role-select-label"
                  value={selectedRole}
                  label="Select Role"
                  onChange={(e) => setSelectedRole(e.target.value)}
                >
                  <MenuItem value="user">App User</MenuItem>
                  <MenuItem value="subscriber">Subscriber</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions className="px-4 py-3">
            <Button
              onClick={() => setOpenPromoteDialog(false)}
              disabled={isSubmittingPromote}
            >
              Cancel
            </Button>
            {selectedRole === "user" ? (
              <Button
                variant="contained"
                color="secondary"
                onClick={handlePromoteUser}
                disabled={isSubmittingPromote}
              >
                {isSubmittingPromote ? "Updating..." : "Update Role"}
              </Button>
            ) : (
              <Button
                variant="contained"
                color="secondary"
                onClick={handlePromoteUser}
                disabled={isSubmittingPromote}
              >
                {isSubmittingPromote ? "Updating..." : "Reback to subscriber"}
              </Button>
            )}
          </DialogActions>
        </Dialog>

        {/* INVITE USER DIALOG */}
        <Dialog
          open={openInviteDialog}
          onClose={() => !isSubmittingInvite && setOpenInviteDialog(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle className="text-lg font-semibold">
            Invite New User
          </DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 1 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Send an invitation email to a new user.
              </Typography>
              <TextField
                fullWidth
                label="Email Address"
                type="email"
                variant="outlined"
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
                sx={{ mt: 2 }}
                autoFocus
              />
            </Box>
          </DialogContent>
          <DialogActions className="px-4 py-3">
            <Button
              onClick={() => setOpenInviteDialog(false)}
              disabled={isSubmittingInvite}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ bgcolor: "#6366f1", "&:hover": { bgcolor: "#4f46e5" } }}
              onClick={handleInviteUser}
              disabled={isSubmittingInvite || !inviteEmail}
            >
              {isSubmittingInvite ? "Sending..." : "Send Invitation"}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default ManageAppUsers;
